module.exports = __webpack_public_path__ + "img/11.87959560.png";